import moment from "moment";

/** Brand primary used across Zenosure UI */
export const BRAND_PRIMARY = "#7367f0";
export const BRAND_DARK = "#172048";

/**
 * Format amount in Indian Rupees.
 * @param {number|string|null|undefined} amount
 * @returns {string}
 */
export const formatCurrency = (amount) => {
  const value = Number(amount);
  if (Number.isNaN(value)) {
    return "₹ 0.00";
  }
  return `₹ ${value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Currency for PDF (Helvetica cannot render ₹ — shows as wrong glyph).
 * @param {number|string|null|undefined} amount
 * @returns {string}
 */
export const formatCurrencyPdf = (amount) => {
  const value = Number(amount);
  if (Number.isNaN(value)) {
    return "Rs. 0.00";
  }
  return `Rs. ${value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Format ISO or DB date for display.
 * @param {string|null|undefined} date
 * @param {string} [format="DD MMM YYYY, hh:mm A"]
 * @returns {string}
 */
export const formatReceiptDate = (date, format = "DD MMM YYYY, hh:mm A") => {
  if (!date) {
    return "N/A";
  }
  const parsed = moment(date);
  return parsed.isValid() ? parsed.format(format) : "N/A";
};

/**
 * Convert HTML plan descriptions to plain text for PDF/display.
 * @param {string|null|undefined} input
 * @returns {string}
 */
export const stripHtmlToText = (input) => {
  if (input == null || input === "") {
    return "—";
  }

  const str = String(input).trim();
  if (!str) {
    return "—";
  }

  if (!/<[a-z][\s\S]*>/i.test(str)) {
    return str;
  }

  const normalized = str
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/li>/gi, "\n")
    .replace(/<li[^>]*>/gi, "• ");

  const div = document.createElement("div");
  div.innerHTML = normalized;

  const text = (div.textContent || div.innerText || "")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim();

  return text || "—";
};
